<template>
  <NavigationHeader title="Trucs et outils en milieu de travail" />
</template>

<script>
export default {
  name: 'ResourcesTrainingHeader'
}
</script>
